import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import types, * as classificators from '../constants/classificators';
import { withTranslation } from 'react-i18next';
import classifiersStore from '../utils/classifiersStore';
import _ from 'lodash';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { translateClassificator } from '../utils/translateHelpers';

const { Option } = Select;

class Classificator extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    value: PropTypes.any,
    allowed: PropTypes.array,
    withUndefinedOption: PropTypes.bool,
    optionFilter: PropTypes.func,
    locale: PropTypes.string,
    alphabetical: PropTypes.bool,
  };

  static types = types;

  render() {
    const {
      type,
      t,
      i18n,
      value,
      allowed,
      withUndefinedOption,
      optionFilter,
      alphabetical,
    } = this.props;
    let options = classificators[type];
    let selectOptions = [];

    if (options) {
      options = _.values(options);

      if (allowed) {
        options = _.filter(options, (item) => allowed.includes(item));
      }

      selectOptions = _.map(options, (key) => (
        <Option key={key} value={key}>
          {t(`classificators.${type}.${key}`)}
        </Option>
      ));
    } else {
      options = classifiersStore.getClassifierByType(type);

      if (!options) {
        throw new Error(`There is no classificator ${type} in system`);
      }

      if (optionFilter) {
        options = _.filter(options, optionFilter);
      }

      if (alphabetical) {
        const tr = translateClassificator(type);
        options = _.sortBy(options, (item) =>
          (tr(item, i18n.language) || '').toLowerCase()
        );
      }

      selectOptions = _.map(options, (item) => {
        const code = classifiersStore.getCode(item);
        const label = translateClassificator(type)(item, i18n.language);
        return (
          <Option key={code} value={code}>
            {label}
          </Option>
        );
      });
    }

    const undefinedOption = (
      <Option key="1" value={null}>
        -
      </Option>
    );

    return (
      <Select
        {...this.props}
        popupMatchSelectWidth={false}
        value={value || undefined}
        key={i18n?.language}
      >
        {withUndefinedOption
          ? [undefinedOption, ...selectOptions]
          : selectOptions}
      </Select>
    );
  }
}

const TranslatedClassificator = withTranslation('common')(Classificator);
hoistNonReactStatics(TranslatedClassificator, Classificator); // 🔴 Temporary fix for HOC static properties

/**
 * 🔴 REMOVE hoistNonReactStatics when refactoring to functional components + hooks.
 * When migrating to hooks:
 * 1. Convert Classificator to a functional component.
 * 2. Use the `useTranslation()` hook instead of `withTranslation()`.
 * 3. Remove this `hoistNonReactStatics` call.
 */
export default TranslatedClassificator;
